import { render, staticRenderFns } from "./ServiceInfoFashionDesign.vue?vue&type=template&id=4111516e&scoped=true&"
import script from "./ServiceInfoFashionDesign.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoFashionDesign.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoFashionDesign.vue?vue&type=style&index=0&id=4111516e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111516e",
  null
  
)

export default component.exports